import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Ticket } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid';
import { getInfo } from "@Components/Grid/components/Table/formatters";

export default function ContestsFinished({ info }) {
  const { definitions: { entityNameModule, entityNamePlural, basePath } } = useGrid()

  const { row } = getInfo(info)

  const { integration_type, configuration } = row
  const { sweep_id = null } = configuration || {}

  const path = useMemo(() => {
    if (basePath) return basePath
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNamePlural, entityNameModule])

  if (integration_type === 'contest_finish' && sweep_id) {
    return <>
      <DefaultTooltip content='See contests finished' side='left'>
        <Link to={`${path}/sweep/${sweep_id}/finished`}>
          <Ticket size={18} />
        </Link>
      </DefaultTooltip>
    </>
  }
  return null
}
